module.exports = __webpack_public_path__ + "static/work34-5a7ce2432fd66c2877b68bc6f98ef456.jpg";